module.exports = __webpack_public_path__ + "img/05.de58cd0d.webp";